import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IFamilyTrailHistory, IFamilyTreeTrail } from 'src/app/common/models/IFamilyTreeTrail';
import 'leader-line';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { FamilyTreeState, FamilyTreeStateModel } from 'src/app/state/family-tree/family-tree.state';
import { FamilyTreeService } from '../services/family-tree.service';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
declare const LeaderLine: any;

@Component({
    selector: 'app-trail-history',
    templateUrl: './trail-history.component.html',
    styleUrls: ['./trail-history.component.scss']
})
export class TrailHistoryComponent implements AfterViewInit, OnDestroy {

    @SelectSnapshot(FamilyTreeState.getFamilyDataState) familyTreeSnapshot: FamilyTreeStateModel | null;
    public trailHistroies: IFamilyTrailHistory;
    public focusedTrail: IFamilyTreeTrail;
    public currentFoculLevel: string;
    lines = [];
    private subscribe = new Subscription();
    constructor(private readonly dialogRef: MatDialogRef<TrailHistoryComponent>,
        private familyTreeService: FamilyTreeService) {
        this.trailHistroies = {
            trailHistory: {},
            trailLevelChangeHistory: {},
            currentFocusLevel: {}
        };

        this.trailHistroies.trailHistory = { ...this.familyTreeSnapshot?.trailHistory };
        this.trailHistroies.trailLevelChangeHistory = { ...this.familyTreeSnapshot?.trailLevelChangeHistory };
        this.trailHistroies.currentFocusLevel = { ...this.familyTreeSnapshot?.currentFocusLevel };
        this.focusedTrail = this.familyTreeSnapshot?.focusedTrail;
        if (Object.keys(this.trailHistroies?.currentFocusLevel)?.length > 0) {
            this.currentFoculLevel = Object.keys(this.trailHistroies.currentFocusLevel)[0];
        }

        this.subscribe = this.dialogRef.beforeClosed().subscribe(() => {
            this.clearTheLine();
        });

    }

    ngOnDestroy(): void {
        if (this.subscribe) {
            this.subscribe.unsubscribe();
        }
    }

    closeDialog() {

        this.dialogRef.close();
    }

    clearTheLine() {
        this.lines.forEach(line => {
            line.remove();
        });
        this.lines = [];
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.createLines();
        }, 300);

    }

    visitTheFamilyNode(level, node) {
        this.closeDialog();
        this.familyTreeService.setFamilyVisitedProfile(level === 'level-1' ? false : true)
            .pipe(take(1)).subscribe(() => {
                setTimeout(() => {
                    this.familyTreeService.changeFromTrailHistoryDialog(level, node);
                }, 1000);

            });
    }


    public resetTree() {
        const newObject = JSON.parse(JSON.stringify(this.trailHistroies));
        Object.keys(newObject?.trailHistory).forEach(element => {
            const history = [...newObject?.trailHistory[element]];
            if (element === 'level-1') {
                newObject.trailHistory[element] = [...[], history[0]];
            } else {
                delete newObject?.trailHistory[element];
            }
        });
        Object.keys(newObject.trailLevelChangeHistory).forEach(element => {
            if (newObject?.trailLevelChangeHistory.hasOwnProperty(element)) {
                delete newObject?.trailLevelChangeHistory[element];
            }
        });

        this.familyTreeService?.setTrailHistory(newObject?.trailHistory);
        this.familyTreeService?.setTrailLevelChangeHistory(newObject?.trailLevelChangeHistory);
        this.familyTreeService.setCurrentFocusLevel({ 'level-1': newObject.trailHistory['level-1'][0] });
        this.familyTreeService.setTrails([...newObject?.trailHistory['level-1']]);
        setTimeout(() => {
            this.familyTreeService.setFamilyVisitedProfile(false).pipe(take(1)).subscribe(() => {
                this.familyTreeService.removeFromFamilyTree(1);
            });

        }, 1000);

        this.trailHistroies = JSON.parse(JSON.stringify(newObject));
        this.createLines();
    }

    public positionLine() {
        this.lines.forEach(line => {
            line.position();
        });
    }

    public createLines() {
        this.clearTheLine();
        if (this.trailHistroies?.trailHistory) {
            const levelsToConnect = Object.keys(this.trailHistroies.trailHistory);
            levelsToConnect.forEach((level, index) => {
                if (index <= levelsToConnect.length - 1) {
                    const startLevelObj = this.trailHistroies.trailLevelChangeHistory[level];
                    const nextLevel = levelsToConnect[index + 1];
                    if (this.trailHistroies.trailHistory.hasOwnProperty(nextLevel)) {
                        const endLevelObj = this.trailHistroies.trailHistory[nextLevel][0];
                        const startDiv = document.getElementById(`${level}${startLevelObj?.id}`);
                        const endDiv = document.getElementById(`${nextLevel}${endLevelObj?.id}`);
                        if (endDiv !== null && startDiv !== null) {
                            const line = new LeaderLine(startDiv, endDiv, {
                                endPlugOutline: false,
                                path: 'grid',
                                startSocket: 'bottom',
                                endSocket: 'top',
                                size: 2,
                                color: '#9e9e9e',
                                positionByWindowResize: false
                            });
                            this.lines.push(line);
                        }
                    }
                }
            });


            const line2 = new LeaderLine(document.getElementById(`nobli-icon-profile`),
                document.getElementById('level-1' + this.trailHistroies.trailHistory['level-1'][0]?.id), {
                endPlugOutline: false,
                startSocket: 'bottom',
                endSocket: 'top',
                size: 2,
                color: '#9e9e9e',
                positionByWindowResize: false
            });
            this.lines.push(line2);
        }
    }


}
